import dayjs from "dayjs";

const formatDate = (date: Date | string) => {
  return dayjs(date).format("MMM-D-YYYY").toUpperCase();
};
const formattedDate = formatDate(new Date());


export const contentData = [
  {
    id: '1',
    heading: ' Appliance Specifications Approval',
    bodyContent: ` Airoom is designing your kitchen per the attached appliance specifications and approved plans. 
Cabinets, countertops, electrical or plumbing will be affected if any deviation from these specifications 
occurs. Please make sure that Airoom is contacted if you decide to purchase any other appliances 
than those listed below ( charges for required changes to plans and cabinetry orders will be passed to 
buyer). <span style="background-color:yellow"> Airoom does not supply service or provide appliance parts. It will be necessary for all required 
appliances, parts and required trim kits are on site at the time of installation. Be sure to review your 
specific needs along with the space and size limitations that may exist for your particular kitchen with 
a qualified appliance dealer. Also be sure to discuss and order any metal appliance trim kits or retrofit 
kits that may be necessary for the installation of cabinet panels. Airoom Architects, Inc. & Airoom, Inc. 
cannot be responsible for appliances that do not conform to space and location considerations that 
are on the approved plan.</span> Please be aware that certain appliances require special cabinet and space 
considerations that may not have been designed for in your kitchen and that these specifics should be 
discussed with your appliance dealer. Appliances that do not fit into the allotted spaces may result in 
additional costs for cabinetry or on-site modifications and will delay completion of your project. 
<br/>
<span style="background-color:yellow"> 
<b>NOTE:</b> If appliances are not yet selected or approved by buyer upon signing of this document it may result 
in delays and additional costs if changes to mechanicals, cabinetry layout or rework of the construction 
documents are required.
</span>
`,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep:___________________________</p>
            <p>Date: ${formattedDate}</p>`,
    footer2: true
  },
  {
    id: '2',
    heading: 'Acceptance of Plans',
    bodyContent: `The undersigned hereby approve(s) the plans (the “plans”), attached hereto, and prepared by Airoom 
Architects Corp., in connection with that certain Sales Contract by and between Airoom, LLC. (“Airoom”) 
and Buyer for the work to be performed at (the “Property”), as the final and approved plans. Buyer 
hereby grants approval to Airoom to order materials based on the design and material selections set 
forth in the plans and attached signed documents.
 Buyer understands, acknowledges and agrees that any changes to the plans requested by Buyer, after 
the Acceptance Date, will result in additional costs to Buyer, and Buyer agrees to be responsible for 
same. In such case Buyer shall be responsible for: 
<div>
<div>
 • Additional charges, based on an hourly rate of $150.00, per hour, to make any drawing or other 
changes to the plans or design and material selections
</div>
<div>
• Charges assessed to repurchase materials
</div>
<div>
 • Any restocking fee or manufacture penalties assessed because of a changed or cancelled order; 
and/or
</div>
<div>
•  Any other fee, cost, charge or expense assessed Airoom that are the result of Buyer’s changes to 
the plans. Buyer agrees to pay these additional charges upon receipt of an invoice from Airoom 
for same.
</div>
</div>
 Buyer also understands, acknowledges and agrees that Airoom shall not be responsible if construction 
shall be delayed or prevented by changes to the plans requested by Buyer after the Acceptance Date or 
because of delays in the delivery of any material selections made after the Acceptance Date.
 IN WITNESS WHEREOF, Buyer has executed this Acceptance of Plans.`,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: ___________________________</p>
            <p>Date: ${formattedDate}</p>`,
    footer2: true
  },
  {
    id: '3',
    heading: '  Appliance Availability Notice',
    bodyContent: ` Global supply chain and manufacturing issues have caused many appliance manufacturers to experience 
shortages with inventory and unpredictable fulfillment schedules. In many cases some appliance 
manufacturers and distributors are pushing lead time out for more than 12 months.
 We know that your appliance needs are important to getting your project complete, but we want you to 
be aware that Airoom, LLC does not sell or control the appliance specified or ordered for your project. 
The appliances you’re purchasing are through Appliance Centers of America, LLC (ACA), which although 
affiliated with Airoom, is not the same company and does not operate in the same way.
<br/>
 <b>Consequently, if Airoom is ready to complete your project but an appliance or appliance part is not 
available, Airoom will not be able to hold up the completion and will expect to be paid in full for work 
under its contract.
 ACA understands the necessity to fulfill your appliance needs so if an appliance is not available when 
Airoom is ready to complete your project, you are free to choose one of the following:</b>
<br/>
<br/>

 • ACA will continue to monitor and update you on the expected delivery of your appliance and will 
delivery and install it when it’s available.
<br/>
<br/>

 • ACA will allow you to change manufacturers using the original purchase amount as an allowance 
against a new product.
<br/>
<br/>

 • ACA will fully refund the amount that was charged for the appliance and remove it from your order. 
You will be free to purchase the appliance from whomever you choose, but ACA and Airoom will 
no longer be responsible for delivery or installation. ACA does not charge for installation, so there 
will be no refund for installation.
<br/>
<br/>

 Everyone in the appliance industry is working through the same constraints so we appreciate your 
patience and want you to be fully informed so that you can make the best decision before purchasing 
your appliances.
 I understand and acknowledge the above regarding possible appliance shortages and the completion 
of my Airoom project:`,
    logoSrc: 'assets/img/ACA-logo.png',
  },
  {
    id: '4',
    heading: '  Authorization to Commence Architectural Plans',
    bodyContent: `  Buyer authorizes Airoom, LLC (“Airoom”) to proceed with producing architectural plans for the scope 
and concepts as discussed and presented on ________________.  Changes and adjustments made to 
the scope of the project will include: 
<div class="mt-4" style="border: 1px solid gray;"></div>
<div class="mt-4" style="border: 1px solid gray;"></div>
<div class="mt-4" style="border: 1px solid gray;"></div>

 <br/>
 <br/>
 And exclude:
 <br/>
<div class="mt-4" style="border: 1px solid gray;"></div>
<div class="mt-4" style="border: 1px solid gray;"></div>
<div class="mt-4" style="border: 1px solid gray;"></div>
 <br/>
 Additional charges or credits, if applicable, will be provided to Buyer at or before Buyer’s first Pre
Construction Conference (“PCC”).   
 <br/>
Once the architectural plans are completed, Buyer and Airoom shall be able to make changes and 
adjustments during the PCC meetings, which will be scheduled with Buyer in anticipation of an estimated 
architectural plans ready date of _____________.`,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: ___________________________</p>
            <p>Date: ${formattedDate}</p>`,
    footer2: true

  },
  {
    id: '5',
    heading: ' Cabinetry Finish Acknowledgement',
    bodyContent: ` As the owner of new cabinetry we want you to be fully informed of the characteristics listed below. It is 
not possible to produce cabinetry products without these characteristics; therefore, it is important that 
you find them acceptable.
<div class="mt-2">
 • <b>Wood Finishes:</b> Over time, all woods and finishes will show signs of natural aging or mellowing. This is caused by the 
effect of natural or artificial light to the wood or finish. Some may get lighter or yellow over time, while others may 
get darker over time.
</div>
<div  class="mt-2">
 •<b>Opaque Finishes on Hardwood:</b> Opaque finishes are applied to the solid wood and veneer surfaces. The grain may 
“telegraph” or show visibly throughout the finish.
</div>
<div  class="mt-2">
 • <b>Joint Fracture:</b> Wood is a product that is in a constant state of expansion and contraction affected by changes in 
temperature and humidity levels in your home. Hairline fractures will be noticeable at the joints on the doors and 
drawer fronts. These hairline cracks will not weaken the finish but they will be visible. The extent of joint fracturing 
will be dependent on the specific climate as well as changes to climate in your home.
</div>
<div  class="mt-2">
 • <b>Stained Hardwoods:</b> Some trees vary in color from shades of white, pink, green, gray and black. Some have even grain 
patterns; others can be quite wild. Some have worm tracks, pin knots, mineral streaks, or open knots. Some absorb 
stain readily; others practically refuse to absorb. Some tend to get darker and some considerably darker (especially 
cherry) as time passes. Because no two pieces of wood are exactly the same, there may be slight variations in color. 
The difference in the grain and patterns add to the naturalbeauty of the wood. Cherry and Maple occasionally have 
mineral streaks that could be darker when stained.
</div>
<div  class="mt-2">
 • <b>Distressed Finishes:</b> All natural characteristics of distressed finishes may be represented in your cabinetry which 
include the following character marks: Splits, Mineral Streaks, Open Knots, Sapwood, Cherry Pin Knots, Worm Holes 
and Lineal Character Marks. It is characteristic of a handcrafted distressed product to have variations occur in the 
amount of distressing. Stained distressed products will have more blackish hang-up occurring in the rough and 
heavily distressed areas. There may also be some difference in color from door to door. These variations in color and 
distressing add to the natural beauty and appearance of the cabinetry.
</div>
 The undersigned understands their responsibility and acknowledges the conditions of this declaration 
and will not hold Airoom LLC responsible for these characteristics.`,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: ___________________________</p>
            <p>Date: ${formattedDate}</p>`,
    footer2: true

  },
  {
    id: '7',
    heading: ' Electric Reroutes & Life Safety Acknowledgement',
    bodyContent: ` <b>REROUTES: </b>Work involved with removing electric openings (kills) may appear to be obvious, but rerouting of existing electrical wiring is not known prior to performing that work. Reroutes are necessary when a switch, outlet or fixture is removed, but the box that housed that device is still feeding power to other areas of your house. For example, if a wall is being removed and an outlet on that wall needs to be killed, it’s possible that electric in another room will also be killed. In that case, a reroute of the electric to that room would be required to restore power. Unless an allowance was charged in your specifications, reroutes are not included with any item that needs to be killed and the associated cost will be presented by your superintendent prior to starting that work.  
<br/>
<br/>
<b>LIFE SAFETY:  </b>
Most building departments will require that your existing home meets current life and safety requirements, like hardwired smoke and carbon monoxide detectors in every bedroom and elsewhere as required. Your contract includes installation of code compliant hard wired smoke detectors as identified in the plans and contract specifications for Airoom’s new work. Replacing, adding or upgrading of smoke detectors and/or carbon monoxide detectors in your existing home is not included unless otherwise specified. Final requirements for that work will be assessed in the field by the electrician and the city inspector.  If additional work is required, the associated cost will be presented by your superintendent prior to starting that work.
 `,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: ___________________________</p>
            <p>Date: ${formattedDate}</p>`,
    footer2: true

  },
  {
    id: '8',
    heading: ' Fixtures, Faucets & Accessories Supplied by Others Disclaimer',
    bodyContent: `Fixtures, faucets, tile and accessories supplied by others and installed by Airoom are exempt from 
Airoom’s guarantees & warrantees. Buyer acknowledges and accepts liability for possible additional 
tradesmen’s trip charges if all required tile, accessories, trim pieces, rough and/or trim valves and parts 
are not available or arrive damaged at time of installation. Buyer is responsible for required product and 
installation specifications, ordering, job site delivery & handling. Airoom installation (if included) is for 
standard product only. Additional charges, if required, to be agreed upon in writing prior to installation. 
Buyer will be responsible for additional costs incurred due to required materials, fixtures, faucets and 
accessories or parts not being available at time of installation. Owner understands that Airoom’s price 
to owner for materials, fixtures, faucets and accessories includes all required design support for the 
selection process as well as 100% responsibility for specifying, ordering, delivery & job site staging of 
materials. Airoom assumes no responsibility for specifying, designing or selecting fixtures, faucets and 
accessories not supplied by Airoom. Additional costs to be incurred by client for design time to select 
materials not being supplied by Airoom or to redesign in the field.
<br/>
 <b>Buyer’s responsibility includes but is not limited to the following:</b>
 <div class='mt-1'>
 • Delivery to job site (includes required truck unloading and handling).
 <div/>
 <div class='mt-1'>

 • Replacement due to damage resulting from shipping or handling.
 <div/>

 <div class='mt-1'>

 • Any required storage.
 <div/>

 <div class='mt-1'>

 • Replacement of any damaged or incorrect parts and any resulting additional labor charges for 
return trips by plumber.
 <div/>

 <div class='mt-1'>

 • Changes to rough plumbing requirements due to final fixture selections shall be charged to Buyer.
 <div/>

 <div class='mt-1'>

 • Any special tile or stone setting materials and grout.
 <div/>

 <div class='mt-1'>

 • Supplying required manufacture installation cut sheets at time of installation.
 <div/>
  `,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: ___________________________</p>
            <p>Date: ${formattedDate}</p>`,
    footer2: true
  },
  {
    id: '9',
    heading: ' Hardwood Flooring Material Acknowledgement',
    bodyContent: ` Hardwood floors are made from real wood, not a manufactured imitation. Because wood is a natural 
material, every piece of flooring will have a unique appearance, often with naturally occurring variations 
in color, texture and grain pattern. Showroom samples and photographic reproductions can give an 
example of the products appearance but they may not be representative of the full range of color, 
texture or grain variations which can occur in the product itself. Prior to installing flooring customers 
should examine the product carefully to ensure it meets their expectations for appearance and quality. 
Flooring that has been installed will be deemed to have been inspected and accepted by the customer. 
Your Airoom field superintendent will review with you prior to installation.  Wood floors will naturally 
undergo a change in color when exposed to the ambient light in a home environment. Generally colors 
become richer and grain patterns more harmonized. The effect, will vary by species.`,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: ___________________________</p>
            <p>Date: ${formattedDate}</p>`,
  },
  {
    id: '10',
    heading: 'Honed Natural Stone Countertop Disclaimer',
    bodyContent: `When choosing a honed natural stone countertop such as marble, granite, and limestone it’s important to know and understand the following:
<div  class='mb-1 mt-1'>
 •  Honed stone requires additional maintenance, (i.e., more frequent applications of sealer to help 
the stone resist staining.)
</div>
<div  class='mb-1'>

 •  Oils from foods or even your hands may be more visible than on other material or stone finishes.
</div>

<div  class='mb-1'>

 •  Darker honed materials may be more apt to show scratches or ’traffic’ patterns.
 </div>
<div class='mb-1'>

 •  There can be no certainty on how a honed countertop will age. The aging process for each kitchen 
will be unique, depending upon a combination of both the material selected and the care and 
maintenance habits selected by the homeowner. 
</div>
Buyer acknowledges and accepts the responsibility for maintaining the honed surface that Buyer has chosen and that none of these characteristics constitute a flaw in the material, fabrication or function of the surface.  `,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: &nbsp;&nbsp;&nbsp;__________________________</p>
            <p>Date: ${formattedDate}</p>`
  },
  {
    id: '11',
    heading: 'Material Deliveries Acknowledgement',
    bodyContent: ` Most of the materials being used to build your project will be delivered to the job site when Airoom 
personnel are either present or have made arrangements with the vendor to put materials in a specific 
location on site. Typically, materials are delivered when needed and not until your project is ready to start. 
However, some small items like cabinetry hardware or small accessories may be delivered via UPS or 
FedEx. We will be purchasing these items long before they are needed to make sure they are available 
and that we obtain your selections prior to any product discontinuations that may occur. In some cases, 
these products may be delivered before we start construction. If this occurs, we ask that you accept the 
package(s) and hold them in a location that you can share with your assigned superintendent once your 
project is ready to start. We do not ask for large packages to be shipped directly to your home. All heavy 
and or large packages will be handled by Airoom personnel and will not be shipped via UPS or FedEx.
<br/>
 If no one is present at the time of delivery the package may be left on your porch. Please let us know 
if you have any special circumstances or concerns or need us to make special considerations for your 
project in this regard. Thank you for your cooperation regarding this matter.`,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: ___________________________</p>
            <p>Date: ${formattedDate}</p>`,
  },
  {
    id: '12',
    heading: ' Natural Stone Countertop Acknowledgement',
    bodyContent: `
<div class='mb-1'>
As stone is a natural product and has a wide range of variability, Buyer needs to be aware that showroom samples are representative only of the color and texture of that selection. Samples will vary in color and texture from the material that will be available at the time of fabrication. As such, Buyer will need to select the actual slabs of material that will be used for Buyer’s project.
</div>
<div class='mb-1'>
Around the time that Buyer’s cabinetry is delivered and installed, the project superintendent will notify Buyer to visit a specific stone supplier to select the slabs of materials to be fabricated. Although somewhat inconvenient, the on-site selection process will assure that the actual slabs being used will have been seen and approved prior to fabrication.  Please note that pricing is based on the material specified and the number of slabs that have been estimated. If Buyer chooses a slab that is different than the original selection, or if more slabs are requested due to layout choices, additional charges may occur.
</div>
The chosen supplier will make every effort to accommodate and assist in the selection of slabs while at their facility. They will also help answer questions regarding the materials that have been chosen.  Should questions arise that require an Airoom’s selection’s specialist to be involved, please let us know.`,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: ___________________________</p>
            <p>Date: ${formattedDate}</p>`,
  },
  {
    id: '13',
    heading: ' Painting & Final Finish Work Acknowledgement',
    bodyContent: `<div class='mb-1 mt-1'> All newly installed drywall for walls and ceilings will be primed by Airoom and paint grade trims will be ordered pre-primed when available.  Unless authorize specified, Airoom is not responsible for final finish work such as painting (including filling of nail holes), staining or other surface finishes for milled stairs and railings. Surface finishes are to be done by others.
</div>
<div class='mb-1'>
Please talk to your project superintendent about when to schedule your painter. You should not have the surfaces prepped or primed until the superintendent has given you the approval to do so. It is the painter’s responsibility to fill nail holes, clean and prepare the surface areas and protect the premises from spills, ladder marks or scratches due to painting work.
</div>
After priming, any imperfections with taping or sanding need to be pointed out to the superintendent before painting begins. The superintendent will touch up any reasonable imperfections at that point. Please note: Airoom cannot be responsible for repainting or finishing if touch ups are required or additional repairs are made after the surfaces are primed or painted.`,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: &nbsp;&nbsp;&nbsp;__________________________</p>
            <p>Date: ${formattedDate}</p>`
  },
  {
    id: '14',
    heading: ' Plumbing Service Upgrade Acknowledgement',
    bodyContent: `<div class='mt-1 mb-1'> The Illinois Plumbing Code requires water services to be sized to handle the scope and number of fixtures in a residence. Specified work for your project may result in the need to upgrade your existing water service, and your local municipality will determine if such work is required. Estimated cost for a water service upgrade is between $8,000 and $15,000. An upgrade to your water service is not included in Airoom’s scope. Buyer is free to contract for that work directly with a qualified water service installer.  Your municipality or Airoom can provide names of qualified installers if requested.  
     </div>
<div class='mb-1'>
The governing municipality will notify Airoom during the permit review phase or during field inspections if an upgrade to the service is required. If so, the extent of the work can be determined in the field by a qualified water service installer. Water service upgrades may require opening public walkways, curbs or streets which will be charged directly to the property owner by the municipality at the time of permit approval or identification of water service upgrade requirement. All applicable fees pertinent to the water service upgrade need to be paid to the municipality as per their guidelines.  </div>`,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: &nbsp;&nbsp;&nbsp;__________________________</p>
            <p>Date: ${formattedDate}</p>`
  },
  {
    id: '15',
    heading: ' Project Funding Confirmation',
    bodyContent: ` Now that your project is moving through the planning phase, it is a good time to review how the work under your Cash Sales 
Contract will be funded. Unless Airoom has agreed to other arrangements in writing, the payment schedule on the face 
of your Contract will be followed. Please acknowledge the payment method for your project by filling out the information 
below, and return this letter to your plan reviewer.
<div class='mb-1 mt-1 ms-3'>
 • Payments will be made in accordance with the Contract Terms and Buyer will be disbursing funds directly to Airoom. 
Any financing contingency to the Contract is hereby waived by Buyer
</div>
 OR;
<div class='mb-1 mt-1 ms-3'>

 • Payments will be made in accordance with the Contract Terms and Buyer will be disbursing funds to Airoom through 
a construction loan originated by Lamb Financial Corporation. Buyer agrees that at any time the balance due on the 
Contract is greater than the remaining undisturbed loan balance that Buyer will fund the difference from Buyer’s 
personal funds prior to any further disbursements being made from the loan.
</div>
<div class='ms-5'>
 Lender: ________________________________ Program: ______________________________
 <div class='mt-1'>
 • Buyer will disburse the funds directly from this loan.
 </div>
 <div>
 • Buyer will disburse the funds from pre-cut checks drawn from this loan.
 </div>
 <div>
 • Buyer will disburse the funds through a construction escrow established by the lender.*
 </div>
 </div>
 OR;
 <div class='ms-3'>
 • Payments will be made in accordance with the Contract Terms and Buyer will be disbursing funds to Airoom through 
a construction loan originated by a lender other than Lamb Financial Corporation. Buyer agrees that at any time 
the balance due on the contract is greater than the remaining undisbursed loan balance that Buyer will fund the 
difference from Buyer’s personal funds prior to any further disbursements being made from the loan.

<div class='mt-1'>
 Lender: ________________________________ Contact Person: ___________________________
 </div>
 <div class='mt-1'>
 Address: ________________________________________________________________________
 </div>
 <div class='mt-1'>

 Phone:__________________ Fax: ____________________ Email: __________________________
 </div>
 <div class='ms-5'>
 <div class='mt-1'>

 • I/we will disburse the funds directly from this loan
 </div>
<div class='mt-1'>
 • I/we will disburse the funds through a construction escrow established*
 </div>
 </div>
 <div class='mt-1'>
 Name of Escrow Agent: ___________________________
 </div>
 <div class='mt-1'>
 Address: _______________________________________
 </div>
 <div class='mt-1'>
 Contact Person: _________________________________
 </div>
 <div class='mt-1'>
 Phone:______________ Fax: ______________ Email: ______________________
 </div>
 <div class='mb-4'>
 <i>
 *Airoom reserves the right to accept or deny any escrow agents or agreement.</i> </div></div>`,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: &nbsp;&nbsp;&nbsp;__________________________</p>
            <p>Date: ${formattedDate}</p>`
  },
  {
    id: '16',
    heading: ' Spacer Bar Acknowledgement',
    bodyContent: ` I/We request that spacer bars not be included with our simulated divided light option on our 
_____________________ window/door order. We recognize this is an option offered by the window 
manufacturer and that our Airoom representative has advised me/us that the spacer bars are an 
integral part of the simulated divided lite option. I/We also understand that without the spacer bar 
design element, the window(s)/door(s) will have an unfinished look.`,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: &nbsp;&nbsp;&nbsp;__________________________</p>
            <p>Date: ${formattedDate}</p>`
  },
  {
    id: '17',
    heading: 'Tuscan Brass Finishes Acknowledgement',
    bodyContent: ` I/We understand and have been informed by our Airoom designer that Tuscan Brass finishes are 
not warranted by the manufacture and is considered a “living finish” that will Bettina over time. The 
following are suggestions by the manufacture to help maintain Tuscan Brass finishes.
<div>
 • It should only be cleaned with mild liquid soap and water.
 <div/>
<div>

 • To remove hard water spots, use a mixture of 50% vinegar and 50% water.
 <div/>

<div>

 • Using cleaners that contain bleach or ammonia will remove oil.
 <div/>

<div>

 • Toothpaste will remove oil.
 <div/>

<div>

 • To help keep the finish longer, use wax (suggested wax brands: Bruno’s Was or Flitz Wax).
 <div/>
 `,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: &nbsp;&nbsp;&nbsp;__________________________</p>
            <p>Date: ${formattedDate}</p>`
  },
  {
    id: '18',
    heading: 'Unfinished Cabinet Bottom Acknowledgement',
    bodyContent: `Buyer has been informed by an Airoom selections specialist and understands that the bottom side of the wall cabinets above the countertop will be unfinished. Buyer understands that if under-cabinet lights are specified the wires and fixtures will be exposed. Buyer has been shown this condition at the and accepts unfinished bottoms for wall cabinets.`,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: &nbsp;&nbsp;&nbsp;__________________________</p>
            <p>Date: ${formattedDate}</p>`
  },
  {
    id: '19',
    heading: ' Window & Exterior Door Approval',
    bodyContent: `<div>Buyer approves the window and exterior door selections per the attached plans as the final approved window and exterior door order.  Buyer grants approval to Airoom to order the window(s) and exterior door(s) based on the design and material selections set forth in the plans and attached signed documents.</div>
<div class='mt-1 mb-1'>
<b>
 Buyer understands, acknowledges and agrees that any changes to the window and exterior door 
order requested by Buyer, after the Acceptance Date, will result in additional costs to Buyer, and 
Buyer agrees to be responsible for same. In such case Buyer shall be responsible for:</b></div>
<div class='ms-5'>
<div>
 •Additional charges, based on an hourly rate of $150.00 per hour to perform changes to design, plans or material selections;
</div>
<div>
 • Charges to repurchase materials;
 </div>
 <div>
 • Restocking fees or manufacture penalties assessed due to a changed or cancelled order; and/or;
</div>
<div>
 • Any other fee, costs, charges or expense assessed as a result of Buyer’s changes to the plans. Buyer agrees to pay these additional charges upon notice.
</div>
</div>
<div class='mt-1 mb-1'>
Buyer also understands that Airoom shall not be responsible for construction delays due to changes in the  window and exterior door order requested by Buyer.
</div>
<div>
 IN WITNESS WHEREOF, Buyer has executed this Window and Exterior Door Approval on this date: </div>`,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: &nbsp;&nbsp;&nbsp;__________________________</p>
            <p>Date: ${formattedDate}</p>`
  },
  {
    id: '20',
    heading: ' Natural Stone Tile Acknowledgement',
    bodyContent: ` <div>
    <p class="mb-1">Homeowners who choose natural stone tile (marble, granite, and limestone) for their project must understand and agree to the following:</p>
    <ul class="list-disc list-inside space-y-2">
      <li>Natural stone requires additional maintenance, (i.e., more frequent applications of sealer to help the stone resist staining).</li>
      <div class='d-flex gap-4 '>
      <div>
      <li>Natural and synthetic oils from foods or even your hands may be more visible than on other materials.</li>
      <li>Darker honed materials may be more apt to show scratches or ‘traffic’ patterns.</li>
      <li>There can be no certainty on how a natural stone will age. The aging process for each installation will be unique, depending upon a combination of both the material selected and the care and maintenance habits selected by the homeowner.</li>
      <li>Natural stone may contain natural iron deposits which may appear as stains after the stone has been installed, especially in wet areas. There is no way to know this until after the stone has been installed and the issue occurs. The company cannot be responsible for this natural condition nor predict when it might happen.</li>
      </div>
       <div class="flex justify-center mb-6">
      <img src="/assets/img/StoneTile.png" alt="Natural Iron Deposits Example" class="rounded-lg shadow-md tile-img-width">
      <p class="text-sm text-gray-500 mt-2 text-center"><i>EXAMPLE OF NATURAL IRON DEPOSITS </i></p>
    </div>
    </div>
      
    </ul>
    <div class="mt-3 mb-1">Understanding the above characteristics of natural stone material will help you to enjoy the qualities that can only be realized with natural stone.</div>
  <div>
     I hereby acknowledge and accept liability for possible markings (i.e., stains, oil build-up, scratches, ‘traffic patterns’, etc.) that may occur on the surface of my natural stone tile after the time of installation.</p>
    </div>
  </div>`,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: &nbsp;&nbsp;&nbsp;__________________________</p>
            <p>Date: ${formattedDate}</p>`
  },
  {
    id: '21',
    heading: ' Natural Stone Countertop Slab Selection Agreement',
    bodyContent: ` Buyer’s final stone slab(s) selections are noted below, and Buyer understands that Airoom will place a non-refundable deposit on this material. Buyer authorizes the slab(s) to be released to the countertop fabricator and understands that the slab(s) will not be returnable or refundable. Buyer agrees that changes to Buyer’s selection after the date of this agreement, will result in additional charges.
<div class='d-flex mt-5 align-items-baseline '>
<div class='w-20'>Stone Yard:</div>
<div class="mt-4 w-100" style="border-bottom: 1px solid gray;"></div>
</div>
<div class='d-flex mt-5  align-items-baseline'>
<div  class='w-20'>Stone Slab:</div>
<div class="mt-4 w-100" style="border-bottom: 1px solid gray;"></div>
</div>
</div>
`,
    footerContent: `<p>Airoom Rep: ___________________________</p>
            <p>Date: ${formattedDate}</p>`
    ,
    footer2: true
  },
];

export const multiplePdfData = [

  {
    id: '21',
    heading: ' Power of Attorney Authorization',
    heading2: 'Power of Attorney Authorization',
    bodyContent: `WHEREAS, Airoom, LLC. (“Airoom”) entered into a Cash Sales Contract for custom construction and remodeling at the address shown above with (herein sometimes referred to individually as the “Buyer” and collectively as the “Buyers”).
 NOW, THEREFORE, Buyers agree as follows (strike out whichever paragraph does not apply):
 Honed countertops (marble, granite, and limestone) have been the countertop of choice throughout 
Europe over the centuries. The discerning culinary aficionados who want the aesthetical attributes that 
only honed materials will bring to their kitchens have sought after the sophisticated, smooth texture of 
honed natural stone. Homeowners who choose this exceptional finish for their counter surface must 
Honed stone requires additional maintenance, (i.e., more frequent applications of sealer to help 
There can be no certainty on how a honed countertop will age. The aging process for each kitchen 
will be unique, depending upon a combination of both the material selected and the care and 
Understanding the above characteristics of honed material will help you to enjoy the qualities that can 
I hereby acknowledge and accept liability for possible markings (i.e., stains, oil build-up, scratches, 
• Buyers hereby appoint each other, individually, and without the consent of the other, to make, agree 
to, and sign off on, any and all change orders, decisions, recommendations and/or Selections 
(as that term is defined in the “Contract”), in connection with the Contract. Buyers agree and 
acknowledge that Airoom may rely on and act upon the decision of either Buyer, as being the 
decision of both Buyers, without obtaining the written or oral consent of both Buyers. The signature 
of one Buyer on any change order or other document in connection with this Contract shall be 
deemed the decision of both Buyers. Airoom shall incur no liability to either Buyer when acting 
upon the consent of one Buyer.
 OR;
 • Buyers hereby appoint (the “Designer”) to make, agree to, and sign off on, any and all change 
orders, decisions, recommendations and/or Selections (as that term is defined in the “Contract”), 
in connection with the Contract, without either Buyer’s or both Buyers’ consent. Buyers agree 
and acknowledge that Airoom may rely on and act upon the decision of the Designer, as being the 
decision of both Buyers, without obtaining the written or oral consent of either or both Buyers. The 
signature of the Designer on any change order or other document in connection with this Contract 
shall be deemed the decision of both Buyers. Airoom shall incur no liability to either Buyer when 
acting upon the consent of the Designer.
 ALSO (strike out whichever paragraph does not apply);
 • This Authorization shall not be effected by either Buyer’s incapacity, and shall continue in effect, 
until written notice of its revocation, signed by both Buyers, is received by Airoom, at Airoom’s 
offices at 6825 N. Lincoln Avenue, Lincolnwood, Illinois 60712, to the Attention of Seymour Turner. 
Anyone at Airoom dealing with one Buyer or the Designer, shall be protected in relying upon the 
authority granted in this Authorization, in the absence of actual knowledge to the contrary.
 • This Authorization shall be binding upon the Buyers, their heirs, successors and assigns.
 • Buyers hereby state, acknowledge and agree that they are fully informed as to the contents of 
this Authorization and understand the full import of this grant of powers to each other or to the 
Designer, as the case may be.`,
    bodyContent2: ` Airoom is designing your kitchen per the attached appliance specifications and approved plans. 
Cabinets, countertops, electrical or plumbing will be affected if any deviation from these specifications 
occurs. Please make sure that Airoom is contacted if you decide to purchase any other appliances 
than those listed below ( charges for required changes to plans and cabinetry orders will be passed to 
buyer). Airoom does not supply service or provide appliance parts. It will be necessary for all required 
appliances, parts and required trim kits are on site at the time of installation. Be sure to review your 
specific needs along with the space and size limitations that may exist for your particular kitchen with 
a qualified appliance dealer. Also be sure to discuss and order any metal appliance trim kits or retrofit 
kits that may be necessary for the installation of cabinet panels. Airoom Architects, Inc. & Airoom, Inc. 
cannot be responsible for appliances that do not conform to space and location considerations that 
are on the approved plan. Please be aware that certain appliances require special cabinet and space 
considerations that may not have been designed for in your kitchen and that these specifics should be 
discussed with your appliance dealer. Appliances that do not fit into the allotted spaces may result in 
additional costs for cabinetry or on-site modifications and will delay completion of your project. 
<br/>
<b>NOTE:</b> If appliances are not yet selected or approved by buyer upon signing of this document it may result 
in delays and additional costs if changes to mechanicals, cabinetry layout or rework of the construction 
documents are required`,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: &nbsp;&nbsp;&nbsp;&nbsp;_________________________</p>
            <p>Date: ${formattedDate}</p>`,
    footerContent2: `<p>Airoom Rep: &nbsp;&nbsp;&nbsp;&nbsp;_________________________</p>
            <p>Date: ${formattedDate}</p>`
  },
  {
    id: '22',
    heading: ' Appliance Specifications Approval',
    heading2: ' Appliance Specifications Approval',
    bodyContent: ` Airoom is designing your kitchen per the attached appliance specifications and approved plans. 
Cabinets, countertops, electrical or plumbing will be affected if any deviation from these specifications 
occurs. Please make sure that Airoom is contacted if you decide to purchase any other appliances 
than those listed below ( charges for required changes to plans and cabinetry orders will be passed to 
buyer). Airoom does not supply service or provide appliance parts. It will be necessary for all required 
appliances, parts and required trim kits are on site at the time of installation. Be sure to review your 
specific needs along with the space and size limitations that may exist for your particular kitchen with 
a qualified appliance dealer. Also be sure to discuss and order any metal appliance trim kits or retrofit 
kits that may be necessary for the installation of cabinet panels. Airoom Architects, Inc. & Airoom, Inc. 
cannot be responsible for appliances that do not conform to space and location considerations that 
are on the approved plan. Please be aware that certain appliances require special cabinet and space 
considerations that may not have been designed for in your kitchen and that these specifics should be 
discussed with your appliance dealer. Appliances that do not fit into the allotted spaces may result in 
additional costs for cabinetry or on-site modifications and will delay completion of your project. 
<br/>
<b>NOTE:</b> If appliances are not yet selected or approved by buyer upon signing of this document it may result 
in delays and additional costs if changes to mechanicals, cabinetry layout or rework of the construction 
documents are required`,
    bodyContent2: ` Airoom is designing your kitchen per the attached appliance specifications and approved plans. 
Cabinets, countertops, electrical or plumbing will be affected if any deviation from these specifications 
occurs. Please make sure that Airoom is contacted if you decide to purchase any other appliances 
than those listed below ( charges for required changes to plans and cabinetry orders will be passed to 
buyer). Airoom does not supply service or provide appliance parts. It will be necessary for all required 
appliances, parts and required trim kits are on site at the time of installation. Be sure to review your 
specific needs along with the space and size limitations that may exist for your particular kitchen with 
a qualified appliance dealer. Also be sure to discuss and order any metal appliance trim kits or retrofit 
kits that may be necessary for the installation of cabinet panels. Airoom Architects, Inc. & Airoom, Inc. 
cannot be responsible for appliances that do not conform to space and location considerations that 
are on the approved plan. Please be aware that certain appliances require special cabinet and space 
considerations that may not have been designed for in your kitchen and that these specifics should be 
discussed with your appliance dealer. Appliances that do not fit into the allotted spaces may result in 
additional costs for cabinetry or on-site modifications and will delay completion of your project. 
<br/>
<b>NOTE:</b> If appliances are not yet selected or approved by buyer upon signing of this document it may result 
in delays and additional costs if changes to mechanicals, cabinetry layout or rework of the construction 
documents are required.`,
    logoSrc: 'assets/img/logo.svg',
    footerContent: `<p>Airoom Rep: &nbsp;&nbsp;&nbsp;&nbsp;__________________________</p>
            <p>Date: ${formattedDate}</p>`,
    footerContent2: `<p>Airoom Rep: &nbsp;&nbsp;&nbsp;&nbsp;__________________________</p>
            <p>Date: ${formattedDate}</p>`
  },
  {
    id: '23',
    heading: ' Natural Stone Countertop Slab Selection Agreement',
    bodyContent: ` Buyer’s final stone slab(s) selections are noted below, and Buyer understands that Airoom will place a non-refundable deposit on this material. Buyer authorizes the slab(s) to be released to the countertop fabricator and understands that the slab(s) will not be returnable or refundable. Buyer agrees that changes to Buyer’s selection after the date of this agreement, will result in additional charges.
<div class='d-flex mt-5 align-items-baseline '>
<div class='w-20'>Stone Yard:</div>
<div class="mt-4 w-100" style="border-bottom: 1px solid gray;"></div>
</div>
<div class='d-flex mt-5  align-items-baseline'>
<div  class='w-20'>Stone Slab:</div>
<div class="mt-4 w-100" style="border-bottom: 1px solid gray;"></div>
</div>
</div>
`
  },
]